import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Typography } from 'antd'
import { ProjectOutlined } from '@ant-design/icons'

// slices
import { supportTaskList, supportState } from './support.slice'
import { loginState } from '../../login/login.slice'

// components
import TaskBoard from './TaskBoard'
import TaskLoading from '../taskLoading'

const { Text } = Typography

const Support = ({ activeTab }) => {
    const dispatch = useDispatch()
    const { userProfile } = useSelector(loginState)
    const { tasks, skipPage, pageLimit, status, initialLoading } =
        useSelector(supportState)

    useEffect(() => {
        if (userProfile?.activeProject?._id && activeTab === 'support') {
            dispatch(
                supportTaskList({
                    skip: skipPage,
                    limit: pageLimit,
                    filter: {
                        projectId: userProfile?.activeProject?._id,
                    },
                    listType: 'status',
                })
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userProfile?.activeProject?._id, activeTab])

    return (
        <>
            <div style={{ margin: 10 }} />
            {userProfile?.activeProject &&
            userProfile?.activeProject?._id &&
            status === 'loaded' &&
            tasks?.length > 0 ? (
                <TaskBoard
                    props={{
                        tasks,
                        filteredAssignees: [],
                        selectedTeamMembers: [],
                    }}
                />
            ) : initialLoading ? (
                <TaskLoading />
            ) : tasks?.length === 0 &&
              status === 'loaded' &&
              userProfile?.activeProject !== null ? (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        rowGap: 10,
                        marginTop: 50,
                    }}
                >
                    <ProjectOutlined
                        style={{
                            fontSize: 30,
                        }}
                    />
                    <Text
                        style={{
                            fontSize: 18,
                        }}
                    >
                        Task is not created yet in this Project, Please create a
                        task
                    </Text>
                </div>
            ) : (
                tasks?.length === 0 &&
                userProfile?.activeProject === null && (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            rowGap: 10,
                            marginTop: 50,
                        }}
                    >
                        <ProjectOutlined
                            style={{
                                fontSize: 30,
                            }}
                        />
                        <Text
                            style={{
                                fontSize: 18,
                            }}
                        >
                            Project is not Active yet in this Task, Please
                            Select the project to make active
                        </Text>
                    </div>
                )
            )}
        </>
    )
}

export default Support
